module.exports = __webpack_public_path__ + "static/media/Гребенникова И.В..ca31f220.pdf";